module.exports = __webpack_public_path__ + "media/images/categories/carousel/technology-and-innovation-513e62f29d1a4c3e7079e843aa33384d.jpg";